import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventManagerService } from '../../service/event-manager.service';
declare let $;

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent implements OnInit, OnDestroy {
  @Input() isSearch = true;
  @Input() isExport = false;
  @Input() isExportXLSX = true;
  @Input() isExportPDF = true;
  @Input() isFilter = false;
  @Input() isTotal = true;
  @Input() total;
  @Input() titleStart;
  @Input() titleEnd;
  @Output() search$: EventEmitter<string> = new EventEmitter();
  subscriptions: Subscription[];
  params: any = {};
  constructor(
    public eventManager: EventManagerService
  ) {

  }
  ngOnInit() {
    this.subscriptions = [...[
      this.eventManager.subscribe(('add-option-search'), (res) => {
        this.addOption(res.content);
      }),
      this.eventManager.subscribe(('get-value-search'), (res) => {
        this.search();
      }),
      this.eventManager.subscribe('body-click', (res) => {
        const e = res.content.event;
        const filterModal = $('#filterModal')[0];
        if ($(e.target).closest('#filterModal').length === 0 && filterModal && filterModal.offsetWidth) {
          $('#hideFilterModal').click();
        };
        const exportModal = $('#exportModal')[0];
        if ($(e.target).closest('#exportModal').length === 0 && exportModal && exportModal.offsetWidth) {
          $('#hideExportModal').click();
        }
      }),
    ]];
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  addOption(object) {
    this.params[object.key] = object.value;
  }
  search() {
    this.search$.emit(this.params);
  }
  exportFile(type) {
    this.eventManager.broadcast({ name: 'export-file' , content: {type}});
    $('#hideExportModal').click();
  }
  filter() {

  }
  reset() {
    this.params = {};
    this.eventManager.broadcast({ name: 'reset-data-filter' , content: {}});

  }
}

